import { lazy } from 'react';

import { ALLOWED_ROLES } from 'packages/utils';

import { PATHS } from './constants';

const Timeline = lazy(() => import('./screens/Timeline'));
const EventDetail = lazy(() => import('./screens/EventDetail'));
const TempEventForm = lazy(() => import('./screens/TempEventForm'));

// More specific paths first: Timeline uses exact:false so `/timeline/drawer/:divId/:eventId`
// keeps the list mounted while the shareable drawer opens.
const routesRoutes = [
  {
    component: TempEventForm,
    path: PATHS.TEMP_CREATE,
    writeOnly: true,
    onOrgChangeRedirectTo: '/:orgId/-',
  },
  {
    component: EventDetail,
    path: PATHS.EVENT_DETAIL,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.EVENTS_SUMMARY.GET,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: Timeline,
    path: PATHS.BASE_URL,
    exact: false,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.EVENTS_SUMMARY.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default routesRoutes;
